export * from './TextInput';
export { StyledInputText } from './TextInput.styles';
